<template>
    <div id="mapFiscan" class="page pageMap">
        <div v-show="!disclaimerDialog" class="map-main">
            <div class="btn-group">
                <button :class="{'active': !isBag}" @click="changeTab('tip')">{{$t('res.tipLib')}}</button>
                <button :class="{'active': isBag && !isEmpty}" @click="changeTab('package')">{{$t('res.bagLib')}}</button>
                <button :class="{'active': isBag && isEmpty}" @click="changeTab('empty')">{{$t('topic.emptyPacket')}}</button>
            </div>
            <el-form class="page-query" :inline="true" size="mini">
                <el-form-item :label="$t('res.imgName')">
                    <el-input v-model="formSearch.byName" :placeholder="$t('tip.name')" clearable></el-input>
                    <el-input type="text" name="notautosubmit" style="display:none"></el-input>
                </el-form-item>
                <el-form-item v-if="isBag && !isEmpty" label="违禁品数量" prop="tipCount" style="margin-bottom: 20px">
                    <el-select v-model="formSearch.tipCount" :placeholder="$t('tip.select')" clearable>
                        <el-option label="1" :value="1" ></el-option>
                        <el-option label="2" :value="2"></el-option>
                        <el-option label="3" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <select-multiple v-if="isEmpty" :nameArrays="selectNames"
                                @getFiscanProductVal="getFiscanProductVal">
                </select-multiple>
                <!-- <select-multiple v-if="isBag && !isEmpty" :nameArrays="selectNames2"
                                @getTipCountVal="getTipCountVal">
                </select-multiple> -->
                <el-form-item>
                    <el-button type="primary" @click="formQuery" round>{{$t('c.query')}}</el-button>
                </el-form-item>
            </el-form>
            <div class="page-table">
                <div v-if="isBag && !isEmpty" class="bag-image-tip">
                    <p class="check-node">
                        <span v-for="(v, i) in bagNodePostion" :key="i">{{v}}{{i===bagNodePostion.length-1?'':' / '}}</span>
                    </p>
                </div>
                <div class="page-operate">
                    <el-button-group>
                        <el-tooltip class="item" effect="dark" :content="$t('res.checkAll')" placement="top-start"
                                    :hide-after="1000">
                            <el-button size="small" @click="handleCheckAllChange"
                                       :class="[checkAll ? 'btn-active': 'btn-not-active']"
                                       :disabled="listData.length==0?true:false">
                                <i class="nucfont inuc-checkall"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="$t('c.clear')" placement="top" :hide-after="1000">
                            <el-button size="small" @click="resetSelect">
                                <i class="nucfont inuc-reset"></i>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip v-show="isDeleteShow" class="item" effect="dark" :content="$t('c.delete')"
                                    placement="top-start"
                                    :hide-after="1000">
                            <el-button size="small" @click="deleteFiscanImgArr">
                                <i class="nucfont inuc-delete"></i>
                            </el-button>
                        </el-tooltip>
                    </el-button-group>

                </div>

                <div class="map-list-box" v-loading="loading">
                    <div class="map-list">
                        <el-checkbox-group v-model="selectFiles">
                            <ul>
                                <li class="map-list-outer" v-for="item in listData" :key="item.id" >
                                    <div class="map-item" @click.stop="checkClick" :class="{'active': selectFiles.includes(item.id)}">
                                        <el-checkbox :label="item.id" :title="$t('c.check')">{{ }}</el-checkbox>
                                        <div class="map-detail" :title="isBag?item.name:item.byName">
                                            <div class="img-wrap">
                                                <img v-if="item._image" class="map-item-img" :src="item._image.url" alt="map images">
                                            </div>
                                            <p class="map-item-name">{{isBag?item.name:item.byName}}</p>
                                        </div>

                                        <ul class="operate-list">
                                            <li @click.stop="openFile(item, $event)"><p>{{$t('c.view')}}</p></li>
                                            <li v-show="userType==1 || userType==4" @click.stop="editImageInfo(item)"><p>{{$t('c.modify')}}</p></li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </el-checkbox-group>
                        <div v-if="!listData.length" class="nodata">
                            <i class="nucfont inuc-empty-file"></i>{{$t('c.noData')}}
                        </div>
                    </div>
                </div>
                <div class="pagination-bar">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        layout="total, prev, pager, next, jumper"
                        :total="pagTotal"
                        :page-size="pageSize">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- <div v-show="!isEmpty" class="map-tree"> -->
        <div v-show="!disclaimerDialog && (!isBag || !isEmpty)" class="fiscan-map-tree">
            <!-- 现右键菜单不开放，若开放请在el-tree加： @node-contextmenu="nodeContextmenu"  -->
            <div class="tip-tree" v-show="!isBag">
                <el-tree
                    ref="fileTree"
                    :data="treeData"
                    show-checkbox
                    node-key="id"
                    @check-change="checkChange"
                    @node-click="treeNodeClick"
                    :props="defaultProps">
                </el-tree>
                <div ref="treeMenu" v-show="menuVisible" class="tree-context-box" style="top: 0; left: 0">
                    <ul id="menu" class="tree-context-content">
                        <li class="menu-item" @click="treeMenuOperation('rename')">{{$t('res.rename')}}</li>
                        <li class="menu-item" @click="treeMenuOperation('delete')">{{$t('res.delete')}}</li>
                        <li class="menu-item" @click="treeMenuOperation('upload')">{{$t('res.upload')}}</li>
                    </ul>
                </div>

            </div>
            <div class="bag-tree" v-show="isBag">
                <el-tree
                    ref="bagFileTree"
                    :data="bagTreeData"
                    node-key="id"
                    :expand-on-click-node="false"
                    :default-expanded-keys="defaultExpandKeys"
                    @node-click="bagTreeNodeClick"
                    :props="defaultProps"
                    >
                </el-tree>
            </div>
        </div>
        <!-- 二级页面 -->
        <fiscan-detail
            ref="fiscanDetail"
            :isBag="isBag"
            :subPage.sync="subPage"
            :showSwitchButton="true"
            @viewImage="viewDR"
            @editImage="editImageInfo">
        </fiscan-detail>

        <el-dialog title="免责声明"
                   width="460px"
                   custom-class="disclaimer-dialog"
                   :visible.sync="disclaimerDialog"
                   :show-close="false"
                   :close-on-click-modal="false"
                   :append-to-body="false"
                   :modal-append-to-body="false"
                   :modal="false"
                   center
        >
            <div class="disclaimer-text">
                {{disclaimerText}}
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="disclaimerAgree">我同意</el-button>
            </div>
        </el-dialog>
        <!-- 修改图像信息 -->
        <el-dialog
            :title="$t('res.editImg')"
            :visible.sync="editImageDialog"
            width="510px"
            :close-on-click-modal="true"
            :modal-append-to-body="false"
            @closed="$refs.editFormDialog && $refs.editFormDialog.resetFields()"
        >
            <el-form
                :model="editImageForm"
                :rules="editImageRule"
                class="edit-image-form"
                ref="editFormDialog"
                label-width="100px">
                <el-form-item :label="$t('c.name')" prop="name">
                    <el-input v-model="editImageForm.name" :placeholder="$t('tip.name')" clearable></el-input>
                </el-form-item>
                <el-form-item :label="$t('c.description')" prop="description">
                    <el-input type="textarea" v-model="editImageForm.description"
                            :autosize="{ minRows: 3, maxRows: 4}"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center">
                <el-button type="primary" @click="saveImageEdit" :loading="editLoading">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import api from '@/api';
    import {Ticket, Storage, Debounce} from '@/utils';
    import ContextMenu from 'vue-context-menu'
    import FiscanDetail from "./FiscanDetail"

    const newMenuData = () => ({id: null})

    export default {
        data() {
            return {
                disclaimerDialog: false,
                disclaimerText: '',

                formSearch: {
                    byName: undefined,
                    tipCount: undefined,
                    products: []
                },
                treeData: [],
                bagTreeData: [],
                listData: [],
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                selectNames: [
                    {
                        key: "fiscanProduct",
                    }
                ],
                selectNames2: [
                    {
                        key: "tipCount",
                    },
                ],

                selectFiles: [], // 多选
                checkAll: false,
                switchStyle: true,
                loading: false,
                pagTotal: 0,
                currentPage: 1,
                pageSize: 30,

                // 单击右键相关
                menuVisible: false,
                contextMenuVisible: false,
                menuData: newMenuData(),
                localID: '',
                queryParams: {},

                equipmentID: undefined,  // 设备id
                knowledgeID: undefined,   //知识点id
                isBag: false,
                subPage: false,
                isEmpty: false,
                //用户图像编辑
                editImageForm: {
                    name: '',
                    description: ''
                },
                editImageRule: {
                    name: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    description: [
                        {max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'},
                    ],
                },
                editImageDialog: false,
                currentEmptyTreeNode: '',  //包裹当前选中的树节点data
                defaultExpandKeys: [0],
                bagNodePostion: [],
                isEquimentNo: false

            }
        },
        created() {
            this.creatorID = Ticket.get().userID
            this.loading = true
            this.BagTreeData = []
            api.getFiscanTree().then(res => {
                this.treeData = res.package;
                this.bagTreeData.push({id:0, name:'全部', type:0, size:0, children:res.package})

                this.$nextTick(() => {
                    $('.tip-tree .el-tree > .el-tree-node').find('.el-checkbox:eq(0)').click();

                    // 文本溢出显示title
                    $('.map-tree').on('mouseenter', '.el-tree-node__label', function () {
                        let width = this.clientWidth;
                        let fullWidth = this.scrollWidth;

                        if (width < fullWidth) {
                            $(this).attr('title', $(this).text())
                        } else {
                            $(this).removeAttr('title')
                        }
                    })
                });
            })

            this.disclaimerKey = `disclaimer_${this.creatorID}`;
            if (!Storage.get(this.disclaimerKey)) {
                this.disclaimerDialog = true;
                api.getDisclaimer().then(res => {
                    this.disclaimerText = res.package;
                })
            }
        },
        mounted() {
            let menuItem = this.$refs.treeMenu;
            $(document).click(e => {
                if ($(".tree-context-box")) {
                    if (!menuItem.contains(e.target)) {
                        this.menuVisible = false;
                    }
                }
            });
        },
        methods: {
            // 免责声明
            disclaimerAgree() {
                this.disclaimerDialog = false;
                Storage.set(this.disclaimerKey, true)
            },
            // 切换元素图库，包裹图库
            changeTab(bag) {
                this.isBag = (bag=='tip')?false:true
                this.isEmpty = (bag=='empty')?true:false
                this.currentEmptyTreeNode =''
                // this.isBag = bag;
                this.loading = true
                this.currentPage = 1;
                this.resetSearch()
                if(this.isBag && !this.isEmpty){
                    $('.fiscan-map-tree .bag-tree .el-tree > .el-tree-node:eq(0)').find('.el-tree-node__content:eq(0)').click()
                } else {
                    this.queryFiscan();
                }

            },
            // 查询元素图像库
            queryFiscan() {
                // if (!this.$refs.fileTree) return;
                // 全选中状态
                let nodeArr = [];
                if(!this.isBag){
                    let checkedNodes = this.$refs.fileTree.getCheckedNodes();
                    checkedNodes.forEach(ele => {
                        let type = ele.type;
                        let id = ele.id;
                        nodeArr.push(`${type}|${id}`);
                    });
                }

                if (!this.isBag&&!nodeArr.length) {
                    this.listData = [];
                    this.pagTotal = 0;
                    setTimeout(() => {
                        this.loading = false;
                    }, 100);
                    return;
                }
                // if(this.isBag) {
                //     if(this.currentEmptyTreeNode.id){
                //         nodeArr.push(`${this.currentEmptyTreeNode.id}`)
                //         nodeArr.push(`${this.currentEmptyTreeNode.type}|${this.currentEmptyTreeNode.id}`)
                //     }
                // }

                this.queryParams = {
                    // knowledges: nodeArr,
                    pageNO: this.currentPage,
                    limit: this.pageSize,
                    ...this.formSearch
                };
                if(this.isBag){
                    if(!this.isEquimentNo){
                        this.queryParams.knowledge = this.currentEmptyTreeNode.id?this.currentEmptyTreeNode.id:''
                    }
                    this.queryParams.productId = this.currentEmptyTreeNode.type?this.currentEmptyTreeNode.type:''
                } else{
                    this.queryParams.knowledges = nodeArr
                }

                let apiUrl = this.isBag?api.getPackageList(this.queryParams):api.getFiscanList(this.queryParams)
                if(this.queryParams.knowledges){
                    delete this.queryParams.knowledges
                }
                if(this.isEmpty) {
                    delete this.queryParams.knowledges
                    delete this.queryParams.tipCount
                    apiUrl = api.getEmptyList(this.queryParams)
                }

                apiUrl.then(res => {
                    this.pagTotal = res.total;

                    let data = res.package;

                    if (!data) return;

                    // 平铺实物图及各视角图
                    let rst = [];
                    data.forEach(item => {

                        if(this.isBag){
                            // 包裹图像
                            let _item = {...item}
                            let images = []
                            images.url = item.url
                            _item._image =images
                            rst.push(_item)
                        } else {
                            // 元素图库
                            if (item.image.physicalMaps.length == 0) {
                                let _item = {...item}
                                let images = []
                                images.url = ''
                                _item._image = images
                                rst.push(_item)
                            } else {
                                let _item = {...item}
                                _item._image = item.image.physicalMaps[0]
                                rst.push(_item)
                            }
                        }
                    })

                    this.listData = rst;

                    // 清空选中状态
                    this.selectFiles = [];
                    setTimeout(() => {
                        this.loading = false;
                    }, 200);
                })
            },

            // 树的选中值发生变化
            checkChange: Debounce(function () {
                this.loading = true
                this.currentPage = 1;
                this.queryFiscan();
            }, 800),
            formQuery() {
                this.loading = true
                this.currentPage = 1;
                this.queryFiscan();
            },
            bagTreeNodeClick(data, node, e){
                if(node.level==2){
                    this.isEquimentNo = true
                }else{
                    this.isEquimentNo = false
                }
                this.currentEmptyTreeNode = data
                this.loading = true
                this.resetSelect()
                this.bagNodePostion = []
                this.getBagTreeParentNode(node)
                this.queryFiscan()
            },
            getBagTreeParentNode(node) {
                if (node) {
                    if (node.parent) {
                        this.bagNodePostion.unshift(node.data.name) //在数组头部添加元素
                        this.getBagTreeParentNode(node.parent) //递归
                    }
                }
            },
            // 单击右键唤醒
            onFileMenuOpen(locals) {
                this.localID = locals.creator
                setTimeout(() => {
                    this.contextMenuVisible = false;
                }, 10);

                this.menuData = locals
            },
            onFileMenuClose(locals) {
            },
            resetFileMenuLocals() {
                this.menuData = newMenuData()
            },
            //修改图库图像名称、知识点、描述
            editImageInfo(data){
                this.editImageDialog = true
                this.currentImageID = data.id
                this.editImageForm.name = data.name
                this.editImageForm.description = data.description
            },
            //保存图像修改
            saveImageEdit() {
                this.$refs['editFormDialog'].validate((valid) => {
                    if (!valid) return
                    this.editLoading = true
                    let data ={
                        name: this.editImageForm.name,
                        description: this.editImageForm.description
                    }

                    let editApi = !this.isBag ? api.putFiscan(this.currentImageID, data):
                                                   api.putPackage(this.currentImageID, data)

                    editApi.then(res => {
                        this.editImageDialog = false
                        this.editLoading = false
                        this.success(this.$t('m.editSuccess'))
                        this.queryFiscan()

                    }).catch(error => this.editLoading = false)
                })
            },
            // 删除图像
            deleteFiscanImgArr() {
                let deleteData = {
                    ids: this.selectFiles
                };
                // if ((this.userType !=1 && this.userType !=4)&& !this.selectFiles.length) {
                //     console.log('this.selectFiles.length: ', this.selectFiles.length);
                //     this.resetSelect()
                //     return this.$message.error(this.$t('res.noAccessToDelete'))
                // }
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    confirmButtonText: this.$t('m.confirm'),
                    cancelButtonText: this.$t('m.cancel'),
                    type: 'warning'
                }).then(() => {
                    let delteApi = !this.isBag ? api.deleteFiscanArr(deleteData):
                                                   api.deletePackageArr(deleteData)
                    delteApi.then(res => {
                        if(res.result){
                            this.$message.success(this.$t('m.delSuccess'));
                            this.resetSelect()
                            this.queryFiscan()
                        }
                    }).catch(() => {

                    })
                })
            },
            deleteFiscanImg(event, menuData) {
                let id = menuData.id;
                this.$confirm(this.$t('m.delete'), this.$t('m.tip'), {
                    confirmButtonText: this.$t('m.confirm'),
                    cancelButtonText: this.$t('m.cancel'),
                    type: 'warning'
                }).then(() => {
                    api.deleteFiscan(id).then(res => {
                        this.$message.success(this.$t('m.delSuccess'));
                        this.queryFiscan();
                    })
                })
            },
            //清空选择
            resetSelect() {
                this.selectFiles = []
                this.checkAll = false
            },
            renameFiscanImg(event, menuData) {
                let id = menuData.id;
                this.$prompt(this.$t('tip.name'), this.$t('m.tip'), {
                    confirmButtonText: this.$t('m.confirm'),
                    cancelButtonText: this.$t('m.cancel'),
                }).then(({value}) => {
                    let paramData = {byname: value, description: undefined}
                    api.putFiscan(id, paramData).then(res => {
                        this.$message.success(this.$t('m.editSuccess'));
                        this.queryFiscan();
                    })
                });

            },
            // 页码变化
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.selectFiles = [];
                this.checkAll = false;
                this.queryFiscan();
            },
            selectFileChange(value) {
                let checkedCount = value.length;
                this.checkAll = (checkedCount === this.listData.length);
            },
            checkClick(e) {
                if (e.target.className === 'el-checkbox__inner') return
                $(e.target).closest('.map-item').find('.el-checkbox input').click()
            },

            // 树形组件右键菜单
            nodeContextmenu(event, object, node, element) {
                if (node.level > 1) {
                    // 获取到根节点。。好疼
                    let item = node.parent;
                    let level = node.parent.level;
                    if (level > 1) {
                        item = item.parent;
                        level = item.level;
                    }
                    this.equipmentID = item.data.id;
                    this.knowledgeID = object.id;

                    this.menuVisible = true;
                    let menu = $(".tree-context-box");
                    menu[0].style.left = event.clientX + "px";
                    menu[0].style.top = event.clientY + "px";

                }
            },
            // 树形控件单击左键隐藏右键菜单
            treeNodeClick() {
                this.menuVisible = false;
            },
            treeMenuOperation(type) {
                if (type === 'rename') {
                    console.log('重命名'+'--equipmentID：'+this.equipmentID + '--knowledgeID：' + this.knowledgeID)
                }
                if (type === 'delete') {
                    console.log('删除'+'--equipmentID：'+this.equipmentID + '--knowledgeID：' + this.knowledgeID)
                }
                if (type === 'upload') {
                    console.log('上传'+'--equipmentID：'+this.equipmentID + '--knowledgeID：' + this.knowledgeID)
                }
            },
            // 查看图像
            openFile(data) {
                // const viewer = $('.images')[0].$viewer;
                // viewer.view(index);
                // if (e.target.className === 'el-checkbox__original' ||
                //     e.target.className === 'el-checkbox__inner') return;

                this.$refs.fiscanDetail.getImageDetail(data.id).then(() => {
                    this.subPage = true;
                })
            },
            closeFile() {
                this.subPage = false;
            },
            handleCheckAllChange(val) {
                if (this.checkAll) {
                    this.selectFiles = [];
                    this.checkAll = false
                } else {
                    let newArr = [];
                    this.listData.forEach((element) => {
                        // if(this.creatorID === element.creator) {
                        newArr.push(element.id);
                        // }
                    });
                    this.selectFiles = newArr;
                    this.checkAll = true;
                }
            },
            getFiscanProductVal(data){
                this.formSearch.products = data.filter(item => item!==0)
            },
            resetSearch() {
                this.formSearch.byName = undefined
                this.formSearch.tipCount = undefined
                this.formSearch.products = []
            }
        },
        computed: {
            isDeleteShow() {
                return this.selectFiles.length > 0
            },
            userType() {
                return Ticket.get().type
            },
        },

        components: {
            ContextMenu,FiscanDetail
        }
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    @include scrollbar();

    .page {
        flex-direction: row;
    }

    .page-query {
        margin-bottom: 0;
        padding-bottom: 0;
    }

    .page-table {
        box-shadow: none;
    }

    #mapFiscan  {
        > .el-dialog__wrapper {
            position: absolute;
        }
        /deep/.el-dialog__header {
            font-weight: 600;
            letter-spacing: 2px;
        }
        .disclaimer-text {
            font-size: 16px;
            line-height: 1.8;
            text-indent: 2em;
            font-family: "Helvetica Neue", Helvetica, "Microsoft YaHei";
        }
        .dialog-footer {
            margin-bottom: 10px;
        }
    }

    .page-operate {
        margin-bottom: 10px;

        .switch-style {
            float: right;
        }
        .btn-active {
            background-color: #22B9FF;
            color: #fff;
        }

        .btn-not-active {
            background-color: #fff;
            color: #606266;
            border-color: #dcdfe6;
            &:hover {
                color: #22B9FF;
                border-color: #bdeaff;
                background-color: #e9f8ff;
            }
        }
    }

    .map-main {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .fiscan-map-tree {
        height: 100%;
        width: 280px;
        margin-left: 20px;
        padding: 10px;
        border: 1px solid #e3e3e3;
        background-color: #fff;
        overflow-y: auto;
        position: relative;

        .tree-context-box {
            position: fixed;
            width: 160px;
            padding: 6px 0;
            background: #fff;
            border: 1px solid #e5e5e5;
            box-shadow: 0 0.5em 1em 0 rgba(0, 0, 0, .1);
            border-radius: 4px;
            z-index: 10;
            .menu-item {
                padding: 6px 10px;
                text-align: center;
                word-spacing: 1px;
                &:hover {
                    background: #42b983;
                    color: #fff
                }
            }
        }
    }
    .btn-group {
        margin-bottom: 15px;

        button {
            margin-right: 10px;
            padding: 8px 28px;
            outline: 0;
            color: #2f3238;
            background-color: #fff;
            border: 1px solid #fff;
            border-radius: 2px;
            cursor: pointer;

            &.active {
                background-color: $color-theme;
                color: #fff;
            }
        }
    }

    .map-list-box {
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-bottom: 15px;
        // border: 1px solid #ddd;
        min-height: 0;

        .map-list {
            // padding: 10px;
            flex: 1;
            background-color: #fff;
            overflow-y: auto;
        }

        .map-list-outer {
            float: left;
            padding: 8px;
            //width: 16.6%;
            width: 12%;

            @media screen and (max-width: 1440px) {
                width: 20%;
            }
        }

    }

    $map-bg: #f1f5fa;
    $map-select-border: #90c3fd;

    .map-item {
        position: relative;
        margin: 0  auto;
        width: 95%;
        border: 1px solid #dcdfe6;
        z-index: 1;
        cursor: pointer;

        // .folder {
        //     width: 70%;
        //     position: relative;
        //     padding-top: 70%;
        //     margin: 0 auto;
        //     background: url(../../assets/images/map/folder.png) center no-repeat;
        //     background-size: cover;

        //     .map-item-img {
        //         position: absolute;
        //         top: 55%;
        //         left: 50%;
        //         transform: translate(-50%, -50%);
        //         max-width: 70%;
        //         max-height: 55%;
        //     }
        // }

        // &-name {
        //     margin: 0 5px 5px 5px;
        //     font-size: 14px;
        //     line-height: 1.4;
        //     text-align: center;
        //     @include no-wrap();
        // }

        .map-detail {
            padding: 5px 0;
            transition: all .3s;
            &:hover {
                background-color: #e9f3ff;
            }
        }

        .img-wrap {
            width: 90%;
            position: relative;
            padding-top: 70%;
            margin: 0 auto;

            .map-item-img {
                position: absolute;
                top: 55%;
                left: 50%;
                transform: translate(-50%, -50%);
                max-width: 100%;
                max-height: 100%;
            }
        }

        .map-item-name {
            margin: 5px 5px 0 5px;
            font-size: 14px;
            line-height: 1.4;
            text-align: center;
            @include no-wrap();
        }

        .el-checkbox {
            position: absolute;
            display: none;
            top: 8px;
            right: 0;
            margin: 0;

            &.is-checked {
                display: block;
            }
        }

        .operate-list {
            display: flex;
            background-color: #fcfcfc;
            border-top: 1px solid #e8e8e8;
            border-radius: 0 0 4px 4px;

            li {
                padding: 10px 0;
                flex: 1;
                font-size: 14px;
                color: rgba(0,0,0,.45);
                text-align: center;
                &:not(:last-child) > p {
                    border-right: 1px solid #e8e8e8;
                }
                &:hover {
                    color: #1890ff;
                }
            }
        }

        &.active {
            border-color: #90c3fd;
            .map-detail {
                background-color: #e9f3ff;
            }
        }
    }

    // 表格形式
    .map-list-table {
        overflow: hidden !important;

        .map-table-tile {
            margin-top: -10px;
            height: 36px;
            line-height: 36px;
            border-bottom: 1px solid #f2f6fd;
            display: flex;

            > li {
                font-size: 12px;
                color: #888;
            }

            .info {
                padding-left: 70px;
            }
            .date {
                padding-right: 70px;
            }
        }
        .map-table-item {
            height: 44px;
            line-height: 44px;
            padding-left: 10px;
            border-bottom: 1px solid #f2f6fd;
            display: flex;

            &:hover {
                background-color: #f6faff;
            }
            .info:hover {
                cursor: pointer;
            }
        }

        .info, .date {
            display: inline-block;
        }
        .info {
            padding-left: 10px;
            //width: 70%;
        }
        .date {
            flex: 1;
            font-size: 12px;
            text-align: right;
            padding-right: 40px;
        }

        .image-box {
            display: inline-block;
            width: 46px;
            height: 38px;
            vertical-align: top;
            cursor: pointer;

            .map-item-img {
                max-width: 70%;
                max-height: 55%;
                margin-top: 10px;
            }
        }
        .map-item-name {
            margin-left: 20px;
        }
        .div-click-disabled {
            cursor: not-allowed;
        }
    }

    .right-menu {
        position: fixed;
        background: #fff;
        z-index: 999;
        display: none;
        border: 1px solid #eee;
        box-shadow: 0 0.5em 1em 0 rgba(0, 0, 0, .1);
        border-radius: 1px;
    }

    .right-menu a {
        margin: 0 auto;
        width: 160px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        display: block;
        color: #1a1a1a;
        padding: 2px;
    }

    .right-menu a:hover {
        background: #42b983;
        color: #fff;
        cursor: pointer;
    }
    //用户图形库下方提醒
    .bag-image-tip{
        margin-bottom: 10px;
        padding: 0 12px;
        height: 32px;
        line-height: 32px;
        background-color: #eee;
        border-radius: 4px;
        .check-node{
            font-size: 12px;
            color: #666;
            @include no-wrap();
            span:last-child {
                font-weight: 600;
            }
        }
        .check-tip{
            color: #22B9FF
        }
    }
    .slot-t-node{
        position: relative;
        z-index: 1;
        .node-name{
            padding-right: 3px;
            .folder-type{
                font-size: 16px;
                &.folder{
                    color: #ffcc00
                }
                &.image{
                    color: #00bcd4
                }
                &.share{
                    color: #a18fe8
                }
            }
            &.copy-move{
                .folder-type.folder,.folder-type.share{
                    color: #999
                }
            }
        }
        .title {
            font-size: 13px;
        }
        &.node-batch {
            .title {
                font-weight: 600;
            }
            .nucfont {
                color: $color-theme;
            }
        }

        &.current-node {
            .title {
                font-weight: 600;
            }
            &:after {
                content: '';
                position: absolute;
                top: -4px;
                bottom: -4px;
                left: -999px;
                right: -999px;
                background-color: #d5edf9;
                z-index: -1;
            }
        }

    }
    .nodata {
        position: absolute;
        top: 50%;
        width: 100%;
        transform: translateY(-50%);
        text-align: center;
        color: #aaa;
        font-size: 16px;
        i {
            margin-right: 5px;
            color: #aaa;
        }
    }


</style>
<style lang="scss">
    // 学员配置该页面的额外css
    #app-student .pageMap {
        .page-query {
            margin-bottom: 0;
            box-shadow: none;
        }
        .page-table {
            margin-bottom: 20px;
            box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
            .map-list-box {
                border-color: #dedede;
            }
        }
        .map-tree {
            padding-top: 10px;
            height: auto;
            margin-top: 84px;
            margin-bottom: 20px;
            border: none;
            box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
        }
    }
    .fiscan-map-tree{
        .bag-tree{
            .el-tree-node{
                &.is-current{
                    >.el-tree-node__content{
                        background-color: #d5edf9;
                    }
                }
            }
        }
    }
</style>
